export default "__VITE_ASSET__DF$gvpvB__"